import {
	Box,
	Container,
	Grid,
	List,
	ListItem,
	ListItemText,
	styled,
	Typography,
} from '@mui/material';
import Logo from '../assets/images/Logo.png';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
	return (
		<Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
			<Grid
				container
				flexDirection={'row'}
				alignItems={'center'}
				justifyContent={'center'}>
				<Box
					component={'img'}
					src={Logo}
					sx={{
						padding: '2px',
						backgroundColor: '#FFFFFF',
						borderRadius: '5px',
					}}
					width={300}
					height={80}
				/>
			</Grid>
			<Box sx={{ mb: 4, mt: 4 }}>
				<Typography fontSize={'28px'} component="h1" gutterBottom>
					Senzcare.AI Privacy Policy
				</Typography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					1. Privacy Policy
				</Typography>
				<StyledTypography>
					When you use SenzCare.AI, your&apos;e trusting us to handle
					your personal and sensitive health-related data responsibly.
					We take that trust seriously.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					2. When this policy applies
				</Typography>
				<StyledTypography>
					We, SenzCare.AI, provide this Privacy Policy to explain how
					we collect, use, and disclose your personal information when
					you interact with us directly—such as when you create an
					account, use our web or mobile applications, or engage with
					features like resident onboarding, care note enhancement, or
					accessibility tools.
				</StyledTypography>
				<StyledTypography sx={{ marginTop: '10px' }}>
					This Privacy Policy also applies when you browse our
					website, use our dashboards, or engage with our AI-powered
					care assistant services.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					3. When this policy doesn&apos;t apply
				</Typography>
				<StyledTypography>
					We may update this Privacy Policy from time to time. If we
					make material changes, we&apos;ll notify you through the
					platform, email or other appropriate methods. In some cases,
					we may seek your consent as required by law.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					4. Policy updates
				</Typography>
				<StyledTypography>
					If you use SenzCare.AI under the management of a care home,
					healthcare organization, or other legal entity, this Privacy
					Policy does not apply to the Customer Personal Data (for
					example, resident medical data, assessments, or records)
					uploaded to that organization&apos;s account. For those
					cases, we act as a processor and handle data on behalf of,
					and according to, that organization&apos;s instructions and
					contractual terms.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					5. Information We Collect
				</Typography>
				<StyledTypography>
					We collect the following types of information:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• Care Notes & Input Data - Text you enter in care note fields." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• AI-Enhanced Notes - Suggestions and updates generated by our AI" />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Feedback - Your feedback on AI suggestions." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Resident Information (when entered by care staff) - Health status, care notes, care plans, summaries, medical history, health status." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Account Information - Such as name, email address, and login credentials." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Technical Data - Device details (mobile), browser type, IP address, and usage data (web)." />
					</StyledListItem>
				</List>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					6. How we use your information
				</Typography>
				<StyledTypography>
					We use the information we collect to:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• Provide and improve SenzCare.AI services (e.g: dashboards, care note enhancements, personalized plan generation and optimization)." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Personalize dashboards and system usability insights." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Securely store caregiver notes and related data." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Improve our services and user experience." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Maintain and manage user accounts." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Ensure platform security, prevent fraud, and comply with regulations." />
					</StyledListItem>
				</List>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					7. Accessibility Services (Mobile App Only)
				</Typography>
				<StyledTypography>
					Our mobile app requires Accessibility Permission to
					function. This is used only to access care note input
					fields, so the app can provide real-time AI suggestions.
				</StyledTypography>
				<StyledTypography sx={{ marginTop: '10px' }}>
					We do not access:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• Password fields" />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Payment information" />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Messages or personal data outside care notes" />
					</StyledListItem>
				</List>
				<StyledTypography sx={{ marginTop: '10px' }}>
					The app cannot function without this permission, but you may
					enable or disable it anytime via your device settings.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					8. Data Storage & Security
				</Typography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• All data is transmitted using encryption." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Notes, enhanced notes, feedback, summaries, medical history and health status are securely stored in our database." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• We do not permanently store unnecessary data." />
					</StyledListItem>
				</List>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					9. How we share your information
				</Typography>
				<StyledTypography>
					We may share your information with:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• Your organization (if applicable): Authorized staff and administrators." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Data may be shared only with trusted service providers (e.g., hosting/cloud services) to operate the Services." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• These providers are bound by strict confidentiality agreements." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Legal authorities: When required by law or to protect rights and safety." />
					</StyledListItem>
				</List>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					10. Data retention
				</Typography>
				<StyledTypography>
					We retain your personal and resident data only as long as
					necessary to provide services or as required by law. If your
					account is closed, data may be anonymized or securely
					deleted
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					11. Your rights & choices
				</Typography>
				<StyledTypography>
					Depending on your location, you may have the right to:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• Access and receive a copy of your data." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Correct inaccurate data." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Restrict or object to processing." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Port your data to another provider." />
					</StyledListItem>
				</List>
				<StyledTypography variant="body1">
					You can manage many of these rights directly within your
					account settings or by contacting us at{' '}
					<Link to="mailto:info@senzmate.com" underline="hover">
						info@senzmate.com
					</Link>
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					12. Security measures
				</Typography>
				<StyledTypography>
					We use industry-standard measures including:
				</StyledTypography>
				<List sx={{ pl: 1 }}>
					<StyledListItem>
						<ListItemText primary="• End-to-end encryption of sensitive data." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Secure authentication and role-based access controls." />
					</StyledListItem>
					<StyledListItem>
						<ListItemText primary="• Continuous monitoring and vulnerability testing." />
					</StyledListItem>
				</List>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					13. Children&apos;s Privacy
				</Typography>
				<StyledTypography>
					Our Services are not directed at children under 13 (or under
					16 where applicable). We do not knowingly collect
					information from children.
				</StyledTypography>
			</Box>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					14. Changes to This Policy
				</Typography>
				<StyledTypography>
					We may update this Privacy Policy from time to time. We will
					notify you of any significant changes by updating the “Last
					Updated” date.
				</StyledTypography>
			</Box>
			<Box>
				<Typography variant="h6" component="h2" gutterBottom>
					15. Need Assistance?
				</Typography>
				<StyledTypography
					variant="body1"
					color="text.secondary"
					gutterBottom>
					If you have questions about this Privacy Policy or your
					rights, you can contact us at:
				</StyledTypography>
				<StyledTypography variant="body1">
					Mail :{' '}
					<Link to="mailto:info@senzmate.com" underline="hover">
						info@senzmate.com
					</Link>
				</StyledTypography>
			</Box>
		</Container>
	);
}

export const StyledListItem = styled(ListItem)(({ theme }) => ({
	paddingTop: '0px',
	paddingBottom: '0px',
	color: '#646464',
	fontSize: '14px',
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
	color: '#324054',
}));

export default PrivacyPolicy;
